import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayerComponent } from '@pool-league/frontend-shared-ui-player';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lib-web-fixture',
  imports: [CommonModule, PlayerComponent, RouterLink],
  templateUrl: './fixture.component.html',
  styleUrl: './fixture.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FixtureComponent {
  readonly playerOneId = input.required<string>();
  readonly playerTwoId = input.required<string>();
  readonly winnerId = input<string>();
  readonly breakerId = input<string>();
  readonly infoTop = input<string>();
  readonly infoBottom = input<string>();
  readonly topLink = input<string | unknown[]>();
}
